import {
    ensureCurrentUser,
    ensureListing,
    ensureOwnListing,
    ensureTransaction,
    ensureUser,
} from './data';

export const CURRENT_USER = user => {
    const ensuredUser = ensureCurrentUser(user);
    const id = ensuredUser?.id?.uuid;
    const profileImage = ensuredUser?.profileImage;
    const attributes = ensuredUser?.attributes;
    const profile = ensuredUser?.attributes?.profile;
    const { privateData, publicData, protectedData, metadata } = profile || {};
    return {
        getId: () => {
            return id;
        },
        getFullData: () => {
            return ensuredUser || {};
        },
        getAttributes: () => {
            return attributes || {};
        },
        getProfile: () => {
            return profile || {};
        },
        getProfileImage: () => {
            return profileImage || {};
        },
        getMetadata: () => {
            return metadata || {};
        },
        getProtectedData: () => {
            return protectedData || {};
        },
        getPrivateData: () => {
            return privateData || {};
        },
        getPublicData: () => {
            return publicData || {};
        },
    };
};

export const USER = user => {
    const ensuredUser = ensureUser(user);
    const fullId = ensuredUser?.id;
    const id = fullId?.uuid;
    const attributes = ensuredUser?.attributes || {};
    const profile = attributes?.profile || {};
    const { privateData, publicData, protectedData, metadata } = profile || {};
    return {
        getFullId: () => {
            return fullId;
        },
        getId: () => {
            return id;
        },
        getFullData: () => {
            return ensuredUser || {};
        },
        getAttributes: () => {
            return attributes || {};
        },
        getProfile: () => {
            return profile || {};
        },
        getMetadata: () => {
            return metadata || {};
        },
        getProtectedData: () => {
            return protectedData || {};
        },
        getPrivateData: () => {
            return privateData || {};
        },
        getPublicData: () => {
            return publicData || {};
        },
    };
};

export const LISTING = listing => {
    const ensuredListing = ensureListing(listing);
    const id = ensuredListing?.id?.uuid;
    const attributes = ensuredListing?.attributes;
    const { privateData, publicData, protectedData, metadata } = attributes || {};
    return {
        getId: () => {
            return id;
        },
        getFullData: () => {
            return ensuredListing || {};
        },
        getAttributes: () => {
            return attributes || {};
        },
        getMetadata: () => {
            return metadata || {};
        },
        getProtectedData: () => {
            return protectedData || {};
        },
        getPrivateData: () => {
            return privateData || {};
        },
        getPublicData: () => {
            return publicData || {};
        },
    };
};

export const OWN_LISTING = listing => {
    const ensuredListing = ensureOwnListing(listing);
    const id = ensuredListing?.id?.uuid;
    const attributes = ensuredListing?.attributes;
    const { privateData, publicData, protectedData, metadata } = attributes || {};

    return {
        getId: () => {
            return id;
        },
        getFullData: () => {
            return ensuredListing || {};
        },
        getAttributes: () => {
            return attributes || {};
        },
        getMetadata: () => {
            return metadata || {};
        },
        getProtectedData: () => {
            return protectedData || {};
        },
        getPrivateData: () => {
            return privateData || {};
        },
        getPublicData: () => {
            return publicData || {};
        },
    };
};

export const TRANSACTION = transaction => {
    const ensuredTransaction = ensureTransaction(transaction);
    const id = ensuredTransaction?.id?.uuid;
    const attributes = ensuredTransaction?.attributes;
    const { privateData, publicData, protectedData, metadata } = attributes || {};
    return {
        getId: () => {
            return id;
        },
        getFullData: () => {
            return ensuredTransaction || {};
        },
        getAttributes: () => {
            return attributes || {};
        },
        getMetadata: () => {
            return metadata || {};
        },
        getProtectedData: () => {
            return protectedData || {};
        },
        getPrivateData: () => {
            return privateData || {};
        },
        getPublicData: () => {
            return publicData || {};
        },
    };
};
